import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'

import * as actions from '../actions'
import Input from '../../common/components/Input'

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
`

const FreeForm = ({
  freeFormChange
}) => (
  <Container>
    <Input
      large
      key='freeform'
      className='bubble-textarea'
      placeholder='Something else?'
      onChange={freeFormChange}
    />
  </Container>
)

const mapDispatchToProps = (dispatch) => ({
  freeFormChange: (value) => dispatch(actions.setFreeText(value))
})

const FreeFormContainer = connect(null, mapDispatchToProps)(FreeForm)

export {FreeFormContainer as default, FreeForm}



// WEBPACK FOOTER //
// ./assets/interview/components/FreeForm.js